import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/home";
import Login from "./pages/login";
import { useEffect } from "react";
import Vehicle from "./pages/vehicle";
import MapPage from "./pages/map";
import { setNavigate } from "./util/navigate";

const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
  const token = Cookies.get("elevatetoken");
  return token ? element : <Navigate to="/login" />;
};

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate); // Set navigate function on app load

    const token = Cookies.get("elevatetoken");
    if (token) navigate("/");
  }, []);

  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute element={<Home />} />} />
      <Route
        path="/vehicle"
        element={<ProtectedRoute element={<Vehicle />} />}
      />
      <Route path="/map" element={<ProtectedRoute element={<MapPage />} />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default App;
